import { Injectable } from '@angular/core';
import { DataProvider } from '../data/data';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../../environments/environment';

@Injectable()
export class CallapiService {
  constructor(private data: DataProvider, public http: HttpClient) {}
  // C001
  public Upload_Regcertificates(
    uuid: string,
    user_uuid: string,
    Pdf_Binary: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        uuid: uuid,
        user_uuid: user_uuid,
        pdf_binary: Pdf_Binary,
      },
    };
    return this.http.post(API_URL + '/regcertificates/upload/', body, {
      responseType: 'json',
      headers,
    });
  }
    // C002
    public Download_Regcertificates(
      user_uuid: string,
      uuid: string
    ): Observable<any> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      });
      const body = {
        data: {
          user_uuid: user_uuid,
          uuid: uuid,
        },
      };
      return this.http.post(API_URL + '/regcertificates/download/', body, {
        responseType: 'json',
        headers,
      });
    }
  // D001
  public Get_Screenauth(uuid: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: uuid,
      },
    };
    return this.http.post(API_URL + '/screenauth/', body, {
      responseType: 'json',
      headers,
    });
  }


  //E002 begin
  public Get_ContractsId(user_uuid: string, uuid): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        uuid:uuid,
      }
    }
    return this.http.post(API_URL + '/contracts/search/id', body, {
      responseType: 'json',
      headers,
    });
  }
  //E002 end


  //E003 begin
  public Get_LoginData(user_uuid: string, mail_address: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        mail_address: mail_address,
      },
    };
    return this.http.post(API_URL + '/contracts/search/login', body, {
      responseType: 'json',
      headers,
    });
  }
  //E003 end

  // E005
  public Update_Contracts(
    user_uuid: string,
    uuid: string,
    start_date: string,
    end_date: string,
    corporate_status: string,
    company_name: string,
    company_name_kana: string,
    postcode: string,
    address_1: string,
    address_2: string,
    address_3: string,
    tel: string,
    mail_address: string,
    staff_last_name: string,
    staff_first_name: string,
    staff_last_name_kana: string,
    staff_first_name_kana: string,
    staff_post: string,
    staff_position: string,
    corporation_form: string,
    users: string,
    acquired_code: string,
    history_flg: string,
    wp_transfer_flg: string,
    call_flg: string,
    health_code: string,
    ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data:{
        user_uuid: user_uuid,
        uuid: uuid,
        start_date: start_date,
        end_date: end_date,
        corporate_status: corporate_status,
        company_name: company_name,
        company_name_kana: company_name_kana,
        postcode: postcode,
        address_1: address_1,
        address_2: address_2,
        address_3: address_3,
        tel: tel,
        mail_address: mail_address,
        staff_last_name: staff_last_name,
        staff_first_name: staff_first_name,
        staff_last_name_kana: staff_last_name_kana,
        staff_first_name_kana: staff_first_name_kana,
        staff_post: staff_post,
        staff_position: staff_position,
        corporation_form: corporation_form,
        users: users,
        acquired_code: acquired_code,
        history_flg: history_flg,
        wp_transfer_flg: wp_transfer_flg,
        call_flg: call_flg,
        health_code: health_code
      }
    };
    return this.http.post(API_URL + '/contracts/id', body, {
      responseType: 'json',
      headers,
    });
  }
  
  // E010 begin
  public Get_UnpaidUser(
    user_uuid: string,
    corporation_no: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data:{
        user_uuid: user_uuid,
        corporation_no: corporation_no
      }
    };
    return this.http.post(API_URL + '/contracts/search/unpaid/user/', body, {
      responseType: 'json',
      headers,
    });
  }
  // E010 end 

  // F001 begin
  public Get_Members(user_uuid: string, corporation_no: string, name: string, user_no: string, use_status: string, casio_id: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        corporation_no: corporation_no,
        name: name,
        user_no: user_no,
        use_status: use_status,
        casio_id: casio_id,
        // confirm_flg: confirm_flg,
      },
    };
    return this.http.post(API_URL + '/members/search', body, {
      responseType: 'json',
      headers,
    });
  }
  // F001 end
  
  // F002 begin
  public Get_MembersId(user_uuid: string, user_code: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        user_code: user_code,
      },
    };
    return this.http.post(API_URL + '/members/search/id', body, {
      responseType: 'json',
      headers,
    });
  }
  // F002 end
  // F003 begin
  public Create_Members(
    user_uuid: string, 
    corporation_no: string, 
    user_last_name: string, 
    user_first_name: string, 
    mail_address: string, 
    user_id_1: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        corporation_no: corporation_no,
        user_last_name: user_last_name,
        user_first_name: user_first_name,
        mail_address: mail_address,
        user_id_1: user_id_1,
      },
    };
    return this.http.post(API_URL + '/members', body, {
      responseType: 'json',
      headers,
    });
  }
  // F003 end

  // F004 begin
  public Update_Members(user_uuid: string, 
    user_code: string, 
    user_last_name: string, 
    user_first_name: string, 
    mail_address: string,
    user_id_1: string,
    user_id_2: string,
    user_id_3: string,): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        user_code: user_code,
        user_last_name: user_last_name,
        user_first_name: user_first_name,
        mail_address: mail_address,
        user_id_1: user_id_1,
        user_id_2: user_id_2,
        user_id_3: user_id_3,
      },
    };
    return this.http.post(API_URL + '/members/id', body, {
      responseType: 'json',
      headers,
    });
  }
  // F004 end
  
  // F005 begin
  public Delete_Members(user_uuid: string, user_code: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        user_code: user_code,
      },
    };
    return this.http.post(API_URL + '/members/status/id', body, {
      responseType: 'json',
      headers,
    });
  }
  // F005 end
  // F006 begin
  public Send_AuthMail(user_uuid: string, user_code: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        user_code: user_code,
      },
    };
    return this.http.post(API_URL + '/members/auth/id', body, {
      responseType: 'json',
      headers,
    });
  }
  // F006 end
  // F007 begin
  public Send_AuthMailAll(user_uuid: string, send_data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        send_data: {
          user_data: send_data
        }
      },
    };
    return this.http.post(API_URL + '/members/auth', body, {
      responseType: 'json',
      headers,
    });
  }
  // F007 end 
  // F008 begin
  public Create_MembersAll(user_uuid: string, corporation_no: string, csv_name: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data:{
        user_uuid: user_uuid,
        corporation_no: corporation_no,
        csv_name: csv_name,
      }
    };
    return this.http.post(API_URL + '/members/all', body, {
      responseType: 'json',
      headers,
    });
  }
  // F008 end 
  // G001 begin
  public Get_UseHistoryData(user_uuid: string, casio_id: string, start_date: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data:{
        user_uuid: user_uuid,
        casio_id: casio_id,
        start_date: start_date
      },
    };
    return this.http.post(API_URL + '/admhistory/id', body, {
      responseType: 'json',
      headers,
    });
  }
  // G001 end

  // J001 begin
  public Get_Notice(user_uuid: string, scope: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
      },
    };
    return this.http.post(API_URL + '/notifications', body, {
      responseType: 'json',
      headers,
    });
  }
  // J001 end

  // I003 begin
  public Send_MailChangeMail(user_uuid: string, uuid: string, new_email: string, time: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
        data:{
            user_uuid: user_uuid,
            uuid: uuid,
            new_email: new_email,
            time: time
        }
    };
    return this.http.post(API_URL + '/cognito/user/sendchangemail', body, {
      responseType: 'json',
      headers,
    });
  }
  // I003 end 

   // I004 begin
   public Update_CognitoMail(crypto_uuid: string, crypto_pattern: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
        data:{
             crypto_uuid: crypto_uuid,
             crypto_pattern: crypto_pattern
        }    
    };
    return this.http.post(API_URL + '/cognito/user/changemail', body, {
      responseType: 'json',
      headers,
    });
  }
  // I004 end 
   // L001 begin
   public Unpaid_User_Payment(user_uuid: string, casio_id: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
        data:{
             user_uuid: user_uuid,
             casio_id: casio_id
        }
    };
    return this.http.post(API_URL + '/payment', body, {
      responseType: 'json',
      headers,
    });
  }
  // L001 end 

  // クーポン申請
  // M001
  public Get_Ticket_Payment(
    user_uuid: string,
    free_flg: string,
    OrderList: any
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        free_flg: free_flg,
        OrderList: OrderList
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/billamount', body, {
      responseType: 'json',
      headers,
    });
  }

  // M002
  public Create_CouponOrder(
    user_uuid: string,
    corporation_uuid: string,
    order_type: string,
    free_flg: string,
    transfer_flg: string,
    OrderList: []
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        corporation_uuid: corporation_uuid,
        order_type: order_type,
        free_flg: free_flg,
        transfer_flg: transfer_flg,
        OrderList: OrderList
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder', body, {
      responseType: 'json',
      headers,
    });
  }

  // M003
  public Get_CouponOrder(
    user_uuid: string,
    scope: string,
    order_date_month: string,
    order_id: string,
    order_type: string,
    company_name: string,
    order_staff: string,
    order_coupon_status: string,
    order_payment_status: string,
    order_quotation: string,
    order_invoice: string,
    order_cancel_flg: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
        order_date_month: order_date_month,
        order_id: order_id,
        order_type: order_type,
        corporation_name: company_name,
        order_staff: order_staff,
        order_coupon_status: order_coupon_status,
        order_payment_status: order_payment_status,
        order_quotation: order_quotation,
        order_invoice: order_invoice,
        order_cancel_flg: order_cancel_flg
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/search', body, {
      responseType: 'json',
      headers,
    });
  }

  // M008
  public Get_CouponCode(
    user_uuid: string,
    scope: string,
    order_id: string,
    corporation_name: string,
    coupon_create_date_month: string,
    coupon_code_1: string,
    coupon_code_2: string,
    coupon_code_3: string,
    order_staff: string,
    coupon_unused : string,
    coupon_use : string,
    coupon_used : string,
    coupon_expired : string,
    coupon_revoked : string,
    coupon_refund : string,
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
        order_id: order_id,
        corporation_name: corporation_name,
        coupon_create_date_month: coupon_create_date_month,
        coupon_code_1: coupon_code_1,
        coupon_code_2: coupon_code_2,
        coupon_code_3: coupon_code_3,
        order_staff: order_staff,
        coupon_status: {
            coupon_unused: coupon_unused,
            coupon_use: coupon_use,
            coupon_used: coupon_used,
            coupon_expired: coupon_expired,
            coupon_revoked: coupon_revoked,
            coupon_refund: coupon_refund
        },
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/coupon/id', body, {
      responseType: 'json',
      headers,
    });
  }

  // M009
  public Get_Product(
    user_uuid: string,
    path_type: string,
    outside_sale_info: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        path_type: path_type,
        outside_sale_info: outside_sale_info
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/search/product', body, {
      responseType: 'json',
      headers,
    });
  }

  // M010
  public Get_Ticket(
    user_uuid: string,
    scope: string,
    coupon_code_1: string,
    coupon_code_2: string,
    coupon_code_3: string,
    ticket_user_name: string,
    search_flg: number
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
        coupon_code_1: coupon_code_1,
        coupon_code_2: coupon_code_2,
        coupon_code_3: coupon_code_3,
        ticket_user_name: ticket_user_name,
        search_flg: search_flg
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/search/ticket', body, {
      responseType: 'json',
      headers,
    });
  }

  // M012
  public Download_Quotation(
    user_uuid: string,
    order_id: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        order_id: order_id
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/download/quotation', body, {
      responseType: 'json',
      headers,
    });
  }

  // M013
  public Download_Invoice(
    user_uuid: string,
    order_id: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        order_id: order_id
      }
    };
    return this.http.post(API_URL + this.data.stub + '/couponorder/download/invoice', body, {
      responseType: 'json',
      headers,
    });
  }

  // 販売企業
  // N003
  public Get_SaleCompanyId(
    user_uuid: string,
    id: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
        data: {
            user_uuid: user_uuid,
            id: id
        }
    };
    return this.http.post(API_URL + this.data.stub + '/salecompany/id', body, {
      responseType: 'json',
      headers,
    });
  }
  // N004
  public Update_SaleCompany(
    user_uuid: string,
    id: string,
    // start_date: string,
    end_date: string,
    corporate_status: string,
    company_name: string,
    company_name_kana: string,
    postcode: string,
    address_1: string,
    address_2: string,
    address_3: string,
    tel: string,
    // mail_address: string,
    business_type: string,
    staff_last_name: string,
    staff_first_name: string,
    staff_last_name_kana: string,
    staff_first_name_kana: string,
    staff_post: string,
    staff_position: string,
    users: Number,
    corporation_form: string,
    acquired_code: string,
    // history_flg: string,
    // call_flg: string,
    // health_code: string
    ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data:{
        user_uuid: user_uuid,
        id: id,
        // start_date: start_date,
        end_date: end_date,
        corporate_status: corporate_status,
        company_name: company_name,
        company_name_kana: company_name_kana,
        postcode: postcode,
        address_1: address_1,
        address_2: address_2,
        address_3: address_3,
        tel: tel,
        business_type: business_type,
        staff_last_name: staff_last_name,
        staff_first_name: staff_first_name,
        staff_last_name_kana: staff_last_name_kana,
        staff_first_name_kana: staff_first_name_kana,
        staff_post: staff_post,
        staff_position: staff_position,
        users: users,
        corporation_form: corporation_form,
        acquired_code: acquired_code,
        // history_flg: history_flg,
        // call_flg: call_flg,
        // health_code: health_code
      }
    };
    return this.http.post(API_URL + '/salecompany/update', body, {
      responseType: 'json',
      headers,
    });
  }
  
  // L004
  public Create_OrdersCsvFile(
    user_uuid: string,
    scope: string,
    order_date_month: string,
    order_id: string,
    order_type: string,
    company_name: string,
    order_staff: string,
    order_coupon_status: string,
    order_payment_status: string,
    order_quotation: string,
    order_invoice: string,
    order_cancel_flg: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
        order_date_month: order_date_month,
        order_id: order_id,
        order_type: order_type,
        company_name: company_name,
        order_staff: order_staff,
        order_coupon_status: order_coupon_status,
        order_payment_status: order_payment_status,
        order_quotation: order_quotation,
        order_invoice: order_invoice,
        order_cancel_flg: order_cancel_flg
      }
    };
    return this.http.post(API_URL + this.data.stub + '/csv/orders', body, {
      responseType: 'json',
      headers,
    });
  }

  // L005
  public Create_CouponsCsvFile(
    user_uuid: string,
    scope: string,
    order_id: string,
    corporation_name: string,
    coupon_create_date_month: string,
    coupon_code_1: string,
    coupon_code_2: string,
    coupon_code_3: string,
    order_staff: string,
    coupon_unused : string,
    coupon_use : string,
    coupon_used : string,
    coupon_expired : string,
    coupon_revoked : string,
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
        order_id: order_id,
        corporation_name: corporation_name,
        coupon_create_date_month: coupon_create_date_month,
        coupon_code_1: coupon_code_1,
        coupon_code_2: coupon_code_2,
        coupon_code_3: coupon_code_3,
        order_staff: order_staff,
        coupon_status: {
            coupon_unused: coupon_unused,
            coupon_use: coupon_use,
            coupon_used: coupon_used,
            coupon_expired: coupon_expired,
            coupon_revoked: coupon_revoked
        },
      }
    };
    return this.http.post(API_URL + this.data.stub + '/csv/coupons', body, {
      responseType: 'json',
      headers,
    });
  }

  // L006
  public Create_TicketsCsvFile(
    user_uuid: string,
    scope: string,
    coupon_code_1: string,
    coupon_code_2: string,
    coupon_code_3: string,
    ticket_user_name: string,
    search_flg: number
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        scope: scope,
        coupon_code_1: coupon_code_1,
        coupon_code_2: coupon_code_2,
        coupon_code_3: coupon_code_3,
        ticket_user_name: ticket_user_name,
        search_flg: search_flg
      }
    };
    return this.http.post(API_URL + this.data.stub + '/csv/tickets', body, {
      responseType: 'json',
      headers,
    });
  }

   // L008
   public Create_MembersCsvFile(
    user_uuid: string,
    corporation_no: string,
    name: string,
    user_no: string,
    use_status: string,
    casio_id: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: localStorage.getItem('token'),
    });
    const body = {
      data: {
        user_uuid: user_uuid,
        corporation_no: corporation_no,
        name: name,
        user_no: user_no,
        use_status: use_status,
        casio_id: casio_id
      }
    };
    return this.http.post(API_URL + this.data.stub + '/csv/members/search', body, {
      responseType: 'json',
      headers,
    });
  }

}
